"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onEnterKey = void 0;
const onEnterKey = handler => event => {
  if (event.key === 'Enter') {
    handler();
  }
};
exports.onEnterKey = onEnterKey;
//# sourceMappingURL=onEnterKey.js.map